import _ from "lodash";

const baseChartOptions = {
  chartTopMargin: 0,
  xAxisNameFontColor: "#959fa4",
  xAxisNameFont: "RobotoMedium",
  xAxisNameFontSize: "9px",
  labelFontSize: "10px",
  labelFont: "RobotoRegular",
  labelFontColor: "#a3a3a3",
  yAxisNameFontColor: "#a3a3a3",
  yAxisNameFont: "RobotoMedium",
  yAxisNameFontSize: "9px",
  yAxisValueFont: "RobotoMedium",
  yAxisValueFontSize: "10px",
  yAxisValueFontColor: "#a3a3a3",
  legendItemFont: "RobotoRegular",
  legendItemFontColor: "#666669",
  legendCaptionAlignment: "center",
  baseFont: "'Roboto', sans-serif",
  baseFontColor: "#a3a3a3",
  xAxisname: "Response Options",
  yAxisName: "# Participants",
  theme: "fusion",
  legendItemFontSize: "10px",
  divLineAlpha: "0",
  divLineDashed: "0",
  legendPosition: "right",
  baseFontSize: "10",
  showXAxisLine: true,
  showYAxisLine: true,
  xaxislinethickness: "1",
  yaxislinethickness: "1",
  xAxisLineColor: "#b0bac9",
  yAxisLineColor: "#b0bac9",
  tooltipBorderAlpha: "0",
  toolTipBgAlpha: "0",
  chartBottomMargin: "0",
  xAxisNamePadding: "5",
  decimals: 0,
  labelDisplay: "wrap",
  maxLabelHeight: "30",
  useEllipsesWhenOverflow: "1",
  maxColWidth: "42",
  maxLabelWidthPercent: "10"
};

const optionHorizontalBarChart = {
  chart: _.cloneDeep(baseChartOptions),
  categories: [],
  dataset: []
};

const optionsPieChart = {
  chart: _.cloneDeep(baseChartOptions),
  data: []
};

const optionsVerticalBarChart = {
  chart: _.cloneDeep(baseChartOptions),
  categories: [],
  dataset: []
};

const optionsLineChart = {
  chart: _.cloneDeep(baseChartOptions),
  categories: [],
  dataset: []
};

const optionsScatterChart = {
  chart: _.cloneDeep(baseChartOptions),
  categories: [],
  dataset: []
};

// --- Vertical Chart ---
optionsVerticalBarChart.chart.xAxisname = "Days in the Study";
optionsVerticalBarChart.chart.yAxisName = "FVC %";
optionsVerticalBarChart.chart.plotSpacePercent = 30;
optionsVerticalBarChart.chart.legendIconScale = "2";
optionsVerticalBarChart.chart.numbersuffix = "%";
optionsVerticalBarChart.chart.chartTopMargin = "";
optionsVerticalBarChart.chart.chartBottomMargin = "";
// optionsVerticalBarChart.chart.showPlotBorder = "1"
// optionsVerticalBarChart.chart.plotBorderThickness = "2"
optionsVerticalBarChart.chart.showLegend = false;

// --- Line Chart ---
optionsLineChart.chart.xAxisname = "Milestone Name";
optionsLineChart.chart.yAxisName = "Participants";
optionsLineChart.chart.canvasPadding = "50";
optionsLineChart.chart.legendIconSides = "4";
optionsLineChart.chart.legendIconRadius = "0";
optionsLineChart.chart.legendIconScale = "2";
// optionsLineChart.chart.legendIconBgColor = "#000"
// optionsLineChart.chart.anchorradius = "0"
// optionsLineChart.chart.drawCustomLegend = "1"
// optionsLineChart.chart.drawCustomLegendIcon = "1"

// --- Scatter Chart ---
optionsScatterChart.chart.xAxisname = "Milestone Name";
optionsScatterChart.chart.yAxisName = "Participants";
optionsScatterChart.chart.canvasPadding = "50";
optionsScatterChart.chart.legendIconScale = "1.5";
// optionsScatterChart.chart.anchorradius = "4"
// optionsScatterChart.chart.drawCustomLegend = "1"
// optionsScatterChart.chart.drawCustomLegendIcon = "1"
// optionsScatterChart.chart.legendIconSides = "0"
// optionsScatterChart.chart.legendIconRadius = "4"

// --- Pie Chart ---
optionsPieChart.chart.legendIconSides = "4";
optionsPieChart.chart.legendIconRadius = "0";
optionsPieChart.chart.legendIconScale = "2";
optionsPieChart.chart.showLabels = false;
optionsPieChart.chart.showValues = false;
optionsPieChart.chart.enableSlicing = false;
optionsPieChart.chart.enableRotation = false;
optionsPieChart.chart.pieRadius = "70%";
optionsPieChart.chart.minimiseWrappingInLegend = true;
optionsPieChart.chart.chartRightMargin = "80";

// --- Horizontal Bar Chart ---
optionHorizontalBarChart.chart.numVisiblePlot = 11;
optionHorizontalBarChart.chart.maxBarHeight = 21;
optionHorizontalBarChart.chart.plotSpacePercent = 40;
optionHorizontalBarChart.chart.showYAxisLine = false;
optionHorizontalBarChart.chart.toolTipBgAlpha = "100";
optionHorizontalBarChart.chart.tooltoolTipBgColor = "#ffffff";
optionHorizontalBarChart.chart.tooltipborderradius = 8;
optionHorizontalBarChart.chart.toolTipPadding = 10;
optionHorizontalBarChart.chart.numDivLines = "0";
optionHorizontalBarChart.chart.yaxismaxvalue = "4";

export { optionHorizontalBarChart, optionsPieChart, optionsVerticalBarChart, optionsLineChart, optionsScatterChart };
